/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_8_P2Inputs */

const en_terms_section_8_p2 = /** @type {(inputs: Terms_Section_8_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles and technical writing here are meant to be useful and to be read. We work to keep them accurate, but we do not guarantee that everything is free of error or right for your particular situation.`)
};

const lv_terms_section_8_p2 = /** @type {(inputs: Terms_Section_8_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raksti un tehniskais saturs šeit ir domāti, lai noderētu un tiktu lasīti. Mēs rūpējamies par to precizitāti, taču negarantējam, ka viss ir bez kļūdām vai piemērots tieši Jūsu situācijai.`)
};

/**
* | output |
* | --- |
* | "Articles and technical writing here are meant to be useful and to be read. We work to keep them accurate, but we do not guarantee that everything is free of ..." |
*
* @param {Terms_Section_8_P2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_8_p2 = /** @type {((inputs?: Terms_Section_8_P2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_8_P2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_8_p2(inputs)
	return en_terms_section_8_p2(inputs)
});